var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p4-report"},[(_vm.show)?_c('VTextField',_vm._b({staticClass:"no-print",attrs:{"dense":"","placeholder":"Type keyword...","autocomplete":"off","prepend-icon":"search"},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}},'VTextField',_vm.$props,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }